//document.addEventListener("DOMContentLoaded", function(){
    
    function darken_screen(yesno){
		if( yesno == true ){
			document.querySelector('.screen-darken').classList.add('active');
		}
		else if(yesno == false){
			document.querySelector('.screen-darken').classList.remove('active');
		}
	}
		
	function close_offcanvas(){
		const offcanvasElement = document.querySelector('#navbar_main');
		// Check if bootstrap is defined before using it
		if (typeof bootstrap !== 'undefined') {
			const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement);
			if (bsOffcanvas) {
				bsOffcanvas.hide();
			}
		} else {
			// Fallback if bootstrap is not available
			offcanvasElement.classList.remove('show');
		}
		document.body.classList.remove('offcanvas-active');
		document.getElementById('navbar_mobile').classList.remove('hide');
		
		// Re-enable page scrolling
		document.body.style.overflow = '';
		
		// Re-enable pointer events on page content
		const pageElements = document.querySelectorAll('#site-main, .hero-banner, .hero-homepage, .hero-text-center, .hero-banner-default, .hero-banner-default-search, .hero-banner-contact-us, footer');
		pageElements.forEach(function(element) {
			if (element) {
				element.style.pointerEvents = '';
			}
		});
	}

	function show_offcanvas(offcanvas_id){
		const offcanvasElement = document.getElementById(offcanvas_id);
		if (offcanvasElement) {
			// Add show class directly to ensure visibility
			offcanvasElement.classList.add('show');
			// Check if bootstrap is defined before using it
			if (typeof bootstrap !== 'undefined') {
				const bsOffcanvas = new bootstrap.Offcanvas(offcanvasElement);
				bsOffcanvas.show();
			}
			document.body.classList.add('offcanvas-active'); 
			document.getElementById('navbar_mobile').classList.add('hide');
			
			// Disable page scrolling when mobile nav is open
			document.body.style.overflow = 'hidden';
			
			// Make the offcanvas menu full height and scrollable
			offcanvasElement.style.height = '100vh';
			offcanvasElement.style.overflowY = 'auto';
			offcanvasElement.style.position = 'fixed';
			
			// Disable pointer events on page content
			const pageElements = document.querySelectorAll('#site-main, .hero-banner, .hero-homepage, .hero-text-center, .hero-banner-default, .hero-banner-default-search, .hero-banner-contact-us, footer');
			pageElements.forEach(function(element) {
				if (element) {
					element.style.pointerEvents = 'none';
				}
			});
		}
	}

	// Wait for DOM to be fully loaded
	document.addEventListener("DOMContentLoaded", function(){
		// Force navbar visibility on all templates
		if (!document.body.classList.contains('home')) {
			var navbarMain = document.getElementById('navbar_main');
			if (navbarMain) {
				navbarMain.style.position = 'static';
				navbarMain.style.transform = 'none';
				navbarMain.style.visibility = 'visible';
				navbarMain.style.height = 'auto';
				
				var navbarInner = navbarMain.querySelector('.navbar');
				if (navbarInner) {
					navbarInner.style.zIndex = '1050';
				}
			}
		}
		
		// Add event listener for media query changes
		var mediaQuery = window.matchMedia('(max-width: 1199.98px)');
		function handleMediaChange(e) {
			var navbarMain = document.getElementById('navbar_main');
			if (e.matches) {
				// Mobile view
				if (navbarMain && navbarMain.classList.contains('show')) {
					navbarMain.style.position = 'fixed';
					document.body.style.overflow = 'hidden';
				}
			} else {
				// Desktop view
				if (navbarMain) {
					navbarMain.style.position = 'static';
					document.body.style.overflow = '';
					
					// Close mobile nav if it's open when switching to desktop
					if (navbarMain.classList.contains('show')) {
						// Close the offcanvas menu
						if (typeof bootstrap !== 'undefined') {
							var bsOffcanvas = bootstrap.Offcanvas.getInstance(navbarMain);
							if (bsOffcanvas) {
								bsOffcanvas.hide();
							}
						} else {
							// Fallback if bootstrap is not available
							navbarMain.classList.remove('show');
						}
						document.body.classList.remove('offcanvas-active');
						var navbarMobile = document.getElementById('navbar_mobile');
						if (navbarMobile) {
							navbarMobile.classList.remove('hide');
						}
					}
				}
			}
		}
		
		// Initial check
		handleMediaChange(mediaQuery);
		
		// Add listener for changes
		if (mediaQuery.addEventListener) {
			mediaQuery.addEventListener('change', handleMediaChange);
		} else {
			// Fallback for older browsers
			mediaQuery.addListener(handleMediaChange);
		}
		
		// Add resize observer with debounce for vanilla JS
		var resizeTimeout;
		window.addEventListener('resize', function() {
			// Clear the timeout if it exists
			if (resizeTimeout) {
				clearTimeout(resizeTimeout);
			}
			
			// Set a timeout to prevent multiple calls
			resizeTimeout = setTimeout(function() {
				handleMediaChange(mediaQuery);
			}, 100);
		});

		document.querySelectorAll('[data-bs-toggle="offcanvas"]').forEach(function(element){
			let offcanvas_id = element.getAttribute('data-bs-target').replace('#', '');
			element.addEventListener('click', function (e) {
				e.preventDefault();
				show_offcanvas(offcanvas_id);
			});
		});

		document.querySelectorAll('.btn-close').forEach(function(button){
			button.addEventListener('click', function (e) { 
				close_offcanvas();
			});
		});
	});
	
//});

(function ($) { 'use strict';

    $(document).ready(function () {
        
        // Search form navbar show/hide input on hover
		$('#bm__search-cta').click(function(){
			if ($('#searchbar').hasClass('hide')) {
				$('#searchbar').removeClass('hide');
			} else {
				$('#searchbar').addClass('hide');
			}
		});
		// navbar background on scroll
		$(function () {
			$(document).scroll(function () {
				var $nav = $(".sticky-top");
				$nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
			});
		});

		// blue logo & search icon on scroll
		$(document).scroll(function () {
			let navbar_main = $("#navbar_main");
			let search = $("#bm__search-cta");

			if($(navbar_main).hasClass('scrolled')){
				$(search).removeClass('white').addClass('blue');
			}else{
				$(search).removeClass('blue').addClass('white');
			}
		});

		// Initialize desktop navbar visibility
		function initDesktopNavbar() {
			if (window.matchMedia("(min-width: 1200px)").matches) {
				// Ensure navbar is visible on desktop
				$("#navbar_main").css({
					"position": "static",
					"transform": "none",
					"visibility": "visible",
					"width": "100%",
					"height": "auto",
					"overflow-y": "visible" // Reset overflow for desktop
				});
				
				// Ensure navbar content has proper z-index
				$("#navbar_main .navbar").css({
					"z-index": "1050"
				});
				
				// Hide mobile navbar
				$("#navbar_mobile").hide();
				
				// Reset body overflow
				$("body").css("overflow", "");
				
				// Close mobile nav if it's open when switching to desktop
				if ($("#navbar_main").hasClass("show")) {
					// Call close_offcanvas function
					close_offcanvas();
				}
			} else {
				// For mobile, ensure the offcanvas has proper height when open
				if ($("#navbar_main").hasClass("show")) {
					$("#navbar_main").css({
						"height": "100vh",
						"overflow-y": "auto"
					});
					
					// Prevent body scrolling
					$("body").css("overflow", "hidden");
				}
			}
		}
		
		// Call on page load and resize
		initDesktopNavbar();
		
		// Create a resize observer to detect window size changes
		let resizeTimeout;
		$(window).on("resize", function() {
			// Clear the timeout if it exists
			if (resizeTimeout) {
				clearTimeout(resizeTimeout);
			}
			
			// Set a timeout to prevent multiple calls
			resizeTimeout = setTimeout(function() {
				initDesktopNavbar();
			}, 100);
		});
		
		// Force navbar visibility on all templates
		if (!$("body").hasClass("home")) {
			$("#navbar_main").css({
				"position": "static !important",
				"transform": "none !important",
				"visibility": "visible !important",
				"height": "auto !important"
			});
			
			$("#navbar_main .navbar").css({
				"z-index": "1050"
			});
		}

		// Handle dropdown parent links - updated for Bootstrap 5
		const $dropdown = $(".dropdown");
		const $dropdownToggle = $(".dropdown-toggle");
		const $dropdownMenu = $(".dropdown-menu");
		const showClass = "show";
		
		// Prevent default on dropdown toggles that have children
		$(document).on('click', '.dropdown-toggle', function(e) {
			if ($(this).next('.dropdown-menu').length > 0) {
				e.preventDefault();
			}
		});
		
		$(window).on("load resize", function() {
			if (this.matchMedia("(min-width: 1200px)").matches) {
				// Enable hover behavior on desktop
				$dropdown.hover(
					function() {
						const $this = $(this);
						$this.addClass(showClass);
						$this.find($dropdownToggle).attr("aria-expanded", "true");
						$this.find($dropdownMenu).addClass(showClass);
					},
					function() {
						const $this = $(this);
						$this.removeClass(showClass);
						$this.find($dropdownToggle).attr("aria-expanded", "false");
						$this.find($dropdownMenu).removeClass(showClass);
					}
				);
				
				// Also handle click for accessibility
				$dropdownToggle.on('click', function(e) {
					e.preventDefault();
					const $parent = $(this).parent();
					
					if ($parent.hasClass(showClass)) {
						$parent.removeClass(showClass);
						$(this).attr("aria-expanded", "false");
						$parent.find($dropdownMenu).removeClass(showClass);
					} else {
						$parent.addClass(showClass);
						$(this).attr("aria-expanded", "true");
						$parent.find($dropdownMenu).addClass(showClass);
					}
				});
			} else {
				// Mobile behavior
				$dropdown.off("mouseenter mouseleave");
				
				// Handle click on mobile
				$dropdownToggle.off('click').on('click', function(e) {
					e.preventDefault();
					const $parent = $(this).parent();
					
					if ($parent.hasClass(showClass)) {
						$parent.removeClass(showClass);
						$(this).attr("aria-expanded", "false");
						$parent.find($dropdownMenu).removeClass(showClass);
					} else {
						// Close other open dropdowns
						$dropdown.removeClass(showClass);
						$dropdownToggle.attr("aria-expanded", "false");
						$dropdownMenu.removeClass(showClass);
						
						// Open this dropdown
						$parent.addClass(showClass);
						$(this).attr("aria-expanded", "true");
						$parent.find($dropdownMenu).addClass(showClass);
					}
				});
			}
		});
		
		// Handle mobile menu height and scrolling on resize
		$(window).on("resize", function() {
			if (window.matchMedia("(max-width: 1199.98px)").matches) {
				if ($("#navbar_main").hasClass("show")) {
					$("#navbar_main").css({
						"height": "100vh",
						"overflow-y": "auto",
						"position": "fixed" // Ensure fixed position on resize
					});
					$("body").css("overflow", "hidden");
					
					// Disable pointer events on page content
					$("#site-main, .hero-banner, .hero-homepage, .hero-text-center, .hero-banner-default, .hero-banner-default-search, .hero-banner-contact-us, footer").css("pointer-events", "none");
				}
			} else {
				// Reset for desktop
				$("body").css("overflow", "");
				$("#navbar_main").css({
					"height": "auto",
					"overflow-y": "visible",
					"position": "static" // Reset position for desktop
				});
				
				// Re-enable pointer events on page content
				$("#site-main, .hero-banner, .hero-homepage, .hero-text-center, .hero-banner-default, .hero-banner-default-search, .hero-banner-contact-us, footer").css("pointer-events", "");
			}
		});
        
    });

}(jQuery));